<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">
                <div class="row justify-content-center">
                    <div class="container text-center mt-5">
                        <ng-container [ngSwitch]="state">
                            <div *ngSwitchCase="'verifying'">
                                <h2>Confirming your payment…</h2>
                                <p>Please do not close this window while we check with Stripe.</p>
                            </div>
                            <div *ngSwitchCase="'paid'">
                                <h2>🎉 Payment Successful!</h2>
                                <p>Please do not close this window, you are being routed to the next screen.</p>
                            </div>
                            <div *ngSwitchCase="'processing'">
                                <h2>Your payment is being processed</h2>
                                <p>Your bank has not finished the transfer yet. Your registration will update automatically
                                    as soon as it completes — there is nothing more you need to do.</p>
                            </div>
                            <div *ngSwitchCase="'not-completed'">
                                <h2>Payment not completed</h2>
                                <p>We did not receive a payment for this checkout, so you have not been charged.
                                    You can go back and try again.</p>
                            </div>
                            <div *ngSwitchCase="'unverified'">
                                <h2>We could not confirm your payment just yet</h2>
                                <p>If you were charged, your registration will update automatically within a few minutes.
                                    You do not need to pay again.</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
